import React, { useCallback, useMemo, useState } from 'react';
import { FlatList, InteractionManager, StyleSheet, } from 'react-native';
import { NativeViewGestureHandler } from 'react-native-gesture-handler';
import { rem } from 'design-system';
import { RewardPreView } from 'features/rewards/components/RewardPreView';
import { useFocusEffect } from '@react-navigation/native';
import useIsTablet from 'hooks/useIsTablet';
export const RewardsGroup = React.memo(({ rewards, onRewardSelect, contentContainerStyle, largerText, ...props }) => {
    const renderItem = useCallback(({ item }) => (<RewardPreView key={item.id} reward={item} largerText={largerText} onPress={(reward) => onRewardSelect?.(reward)} {...props}/>), [largerText, onRewardSelect, props]);
    const isTablet = useIsTablet();
    const [removeClippedSubviews, setRemoveClippedSubviews] = useState(true);
    useFocusEffect(useCallback(() => {
        if (isTablet) {
            let timeout;
            const task = InteractionManager.runAfterInteractions(() => {
                timeout = setTimeout(() => {
                    setRemoveClippedSubviews(false);
                }, 200);
            });
            return () => {
                task.cancel();
                clearTimeout(timeout);
                setRemoveClippedSubviews(true);
            };
        }
        return () => { };
    }, [isTablet]));
    const memoizedContentContainerStyle = useMemo(() => [styles.list, contentContainerStyle], [contentContainerStyle]);
    return (<NativeViewGestureHandler disallowInterruption>
        <FlatList horizontal data={rewards} initialNumToRender={6} renderItem={renderItem} showsHorizontalScrollIndicator={false} contentContainerStyle={memoizedContentContainerStyle} removeClippedSubviews={removeClippedSubviews}/>
      </NativeViewGestureHandler>);
});
RewardsGroup.displayName = 'RewardsGroup';
const styles = StyleSheet.create({
    list: {
        padding: rem(8),
        // Each item already ends with an 8 margin
        paddingRight: 0,
    },
});
